import * as React from "react";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
const SvgSubscription = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		fill: "inherit",
		fillRule: "evenodd",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M21 11v6.25c0 .971-.801 1.75-1.8 1.75H4.8c-.999 0-1.8-.779-1.8-1.75L3.005 11H3V8h.008l.001-1.25C3.009 5.779 3.801 5 4.8 5h14.4c.999 0 1.8.779 1.8 1.75V8H3.008l-.003 3H21z",
			fillRule: "nonzero"
		})
	})
});
export default SvgSubscription;
